export const COMPANY_CONFIG_BASE_PATH = "/onboarding";
